module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=GG - Guernsey.4692a05f.svg";